import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, GeneralConfigType, InteractionType, KeyValueSet, LocalService, PageKey, Status, Wrappers15 } from 'src/service/local.service';
import { PurchaseEntryService } from 'src/service/purchase-entry.service';

@Component({
  selector: 'app-purchase-entries',
  templateUrl: './purchase-entries.component.html',
  styleUrl: './purchase-entries.component.scss'
})
export class PurchaseEntriesComponent {
  lstSectionConfigKeys: string[] = ["common", "table", "purchase_entry"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  source: Wrappers15; isOpenPurchaseEntry = false; selectedPurchaseEntryId: string = '';
  isShowInActive: boolean = false;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private purchaseEntryService: PurchaseEntryService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.PurchaseEntries, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onSetPurchaseEntryTypes();
  }

  purchaseEntryTypes: KeyValueSet[] = []; selectedPurchaseEntryType: string = '1';
  onSetPurchaseEntryTypes() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PurchaseEntryType, true, false).subscribe(result => {
      this.purchaseEntryTypes = result;
    });
  }

  isProcessing = false;
  onLoad() {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.purchaseEntryService.getPurchaseEntries(this.businessId, parseInt(this.selectedPurchaseEntryType), this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
        this.source = result;
        this.isProcessing = false;
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedPurchaseEntryId = key;
        this.isOpenPurchaseEntry = true;
      } break;
    }
  }

  onActiveInactiveStatus(key: string) {
    this.purchaseEntryService.activeInactiveStatus(key, ActiveInactiveFor.PurchaseEntry).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }
}
